import { render } from "./RPDefault.vue?vue&type=template&id=47e92d3e&scoped=true&ts=true"
import script from "./RPDefault.vue?vue&type=script&lang=ts"
export * from "./RPDefault.vue?vue&type=script&lang=ts"

import "./RPDefault.vue?vue&type=style&index=0&id=47e92d3e&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e92d3e"]])

export default __exports__